<template>
  <div id="rightBtm">
    <div class="bg-color-black">
      <myTitle :icon="'chart-line'">维修场景</myTitle>
      <div style="height: 80%;" class=" d-flex jc-around ai-center">
        <div class="item" v-for="item in list" :key="item">
          <img :src="item" />
        </div>
      </div>
    </div>
  </div>
</template>
    
<script>
import myTitle from '@/components/common/title'
export default {
  data() {
    return {
      list: [
        require('../../../assets/wuye1.jpg'),
        require('../../../assets/wuye2.jpg'),
        require('../../../assets/wuye3.jpg'),
      ]
    }
  },
  components: {
    myTitle
  },
}
</script>
    
<style lang="scss" scoped>
$box-height: 300px;
$box-width: 100%;

#rightBtm {
  padding: 20px 16px;
  height: $box-height;
  width: $box-width;
  border-radius: 5px;

  .bg-color-black {
    height: $box-height - 35px;
    border-radius: 10px;
  }

  .item {
    // width: 46%;
    height: 80%;
    text-align: center;
  }

  .title {
    line-height: 40px;
    text-align: center;
    margin-left: -30px;
    padding-top: 5px;
  }

  .text {
    color: #c3cbde;
    padding-left: 30px;
  }

  img {
    height: 100%;
  }
}
</style>
    